/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum LegalEntityType {
    UNKNOWN = 'unknown',
    COUNTERPARTS = 'counterparts',
    INTERNAL = 'internal',
    OTHER = 'other',
}
